import React from "react";
import { Link, useNavigate } from "react-router-dom";

import {
    FaUserCircle,
    FaUser,
    FaIdCard,
    FaCog,
    FaSignOutAlt,
    FaGlobe,
    FaChevronDown
} from "react-icons/fa";

import { useTranslation } from "react-i18next";

import LanguageSelector from "../../components/language/LanguageSelector";

import {
    BASE_URL
} from "../../utils/serverContextPath";
import {
    getLoggedInUser,
    logout
} from "../../pages/userapp/ServiceUserApp";

export default function UserMenu() {

    const navigate = useNavigate();

    const { t } = useTranslation();

    const user = getLoggedInUser();

    //----------------------------------------------------
    // Non connecté
    //----------------------------------------------------

    if (!user) {
        return null;
    }

    //----------------------------------------------------
    // Photo
    //----------------------------------------------------

    const photo = user.photoUrl
        ? `${BASE_URL}userapp/downloadprofile/${user.id}`
        : null;

    //----------------------------------------------------
    // Déconnexion
    //----------------------------------------------------

    const handleLogout = () => {

        logout();

        navigate("/login");

        window.location.reload();

    };

    //----------------------------------------------------

    return (

        <div className="dropdown">

            <button
                className="btn btn-light border dropdown-toggle d-flex align-items-center"
                type="button"
                data-bs-toggle="dropdown"
            >

                {
                    photo ?

                        <img
                            src={photo}
                            alt={user.fullName}
                            width="44"
                            height="44"
                            className="rounded-circle me-2 border border-success"
                            style={{
                                objectFit: "cover"
                            }}
                            onError={(e) => {

                                e.target.style.display = "none";

                            }}
                        />

                        :

                        <FaUserCircle
                            size={42}
                            className="text-success me-2"
                        />
                }

                <div className="text-start me-2">

                    <div
                        className="fw-bold"
                        style={{
                            lineHeight: "18px"
                        }}
                    >
                        {user.fullName}
                    </div>

                    <small className="text-muted">

                        {user.email}

                    </small>

                </div>

                <FaChevronDown />

            </button>

            <ul
                className="dropdown-menu dropdown-menu-end shadow-lg border-0"
                style={{
                    minWidth: 320
                }}
            >

                <li>

                    <div className="px-3 py-3">

                        <div className="fw-bold fs-6">

                            {user.fullName}

                        </div>

                        <small className="text-muted">

                            {user.email}

                        </small>

                    </div>

                </li>

                <li>

                    <hr className="dropdown-divider"/>

                </li>

                <li>

                    <Link
                        className="dropdown-item"
                        to={`/profile/${user.id}`}
                    >

                        <FaUser className="me-2 text-success"/>

                        {t("menu.profile")}

                    </Link>

                </li>





                <li>

                    <hr className="dropdown-divider"/>

                </li>

                <li className="px-3">

                    <div
                        className="d-flex align-items-center mb-2 fw-bold text-success"
                    >

                        <FaGlobe className="me-2"/>

                        {t("menu.language")}

                    </div>

                    <LanguageSelector/>

                </li>

                <li>

                    <hr className="dropdown-divider"/>

                </li>

                <li>

                    <button
                        className="dropdown-item text-danger"
                        onClick={handleLogout}
                    >

                        <FaSignOutAlt className="me-2"/>

                        {t("menu.logout")}

                    </button>

                </li>

            </ul>

        </div>

    );

}